import { registerPlugin } from '@capacitor/core';
const Shamir = registerPlugin('Shamir', {
    web: () => import('./web').then((m) => new m.ShamirWeb()),
});
export * from './definitions';
export const updateShamirWebFsIndexedDbConfig = (config) => {
    Shamir.updateShamirWebFsIndexedDbConfig(config);
};
export { Shamir };
//# sourceMappingURL=index.js.map